import React from 'react'
import Pagination from '@mui/material/Pagination';


export default function PaginationCom(props) {

    return (

        <Pagination count={props.count} page={props.page} color="primary"  onChange={(event, value) => {props.setpage(value)}}  />

      )

}